import { assert } from '../app/logger.js';
import { services } from '../app/services.js';
import { AsyncDataPipeableArray } from '../base/pipeable/async_data_pipeable_array.js';

class Weather extends AsyncDataPipeableArray {
  request({ loc, startDate, duration }) {
    assert(loc, `[data] weather: no loc given`);
    assert(startDate, `[data] weather: no startDate given`);
    assert(duration, `[data] weather: no duration given`);

    this.#loc = loc;
    this.#startDate = startDate;
    this.#duration = duration;

    return this.load();
  }

  get dataClassName() {
    return 'weather';
  }

  getLoadPromise() {
    return this.#loc
      ? services.weather.getWeather({
          lat: this.#loc?.lat,
          lng: this.#loc?.lng,
          startDate: this.#startDate,
          duration: this.#duration,
        })
      : [];
  }

  static Sort = (a, b) => a.date - b.date;

  #loc;
  #startDate;
  #duration;
}

export { Weather };
